import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsNotEmptyObject,
  IsNumber,
  IsObject,
  IsOptional,
  ValidateNested,
} from 'class-validator';
import { SweetFaceTerminalFunctionsConfiguration } from '../../interface';

export class TerminalFunctions {
  @IsBoolean()
  refund: boolean;

  @IsBoolean()
  wallet: boolean;

  @IsBoolean()
  deposits: boolean;

  @IsBoolean()
  tickets: boolean;

  @IsBoolean()
  giftCards: boolean;

  @IsBoolean()
  invoices: boolean;

  @IsBoolean()
  saleAmount: boolean;

  @IsBoolean()
  preAuth: boolean;
}

export class SaveSweetFaceTerminalFunctionConfigurationDto {
  // @ApiProperty({ description: 'Terminal Functios ID' })savesavesave4
  @IsOptional()
  @IsNumber()
  id?: number;

  // @ApiProperty({ description: 'Terminal ID' })
  @IsNumber()
  terminalId: number;

  // @ApiProperty({ description: 'Terminal Functions' })
  @Type(() => TerminalFunctions)
  @ValidateNested()
  @IsObject()
  @IsNotEmptyObject()
  functions: TerminalFunctions;

  private constructor(
    id: number,
    terminalId: number,
    functions: SweetFaceTerminalFunctionsConfiguration
  ) {
    this.id = id;
    this.terminalId = terminalId;
    this.functions = functions;
  }

  static create(input: {
    id?: number;
    terminalId: number;
    functions: SweetFaceTerminalFunctionsConfiguration;
  }): SaveSweetFaceTerminalFunctionConfigurationDto {
    return new SaveSweetFaceTerminalFunctionConfigurationDto(
      input.id,
      input.terminalId,
      input.functions
    );
  }
}
